module.exports = __webpack_public_path__ + "img/explicacao5.82bc3b70.png";